import React from 'react';

import { DivStyled, DivGlobalStyled } from './ColoredBlock.style';

interface Props {
  themeColor: 'safe' | 'info';
  icon: string;
  text: string | JSX.Element | JSX.Element[];
  buttonText: string | JSX.Element;
  buttonIcon?: string;
}

export const ColoredBlock: React.FunctionComponent<Props> = ({ themeColor, icon, text, buttonText, buttonIcon }: Props) => {
  const theme = () => {
    switch (themeColor) {
    case 'safe':
      return {
        'background-color': '#e4ffdd',
        colorText: '#4dc130',
        buttonColor: '#c7f6bc',
      };
    case 'info':
      return {
        'background-color': '#ddf9ff',
        colorText: '#3380c8',
        buttonColor: '#b9ecf8',
      };
    default:
      return {
        'background-color': '#ddf9ff',
        colorText: '#3380c8',
        buttonColor: '#b9ecf8',
      };
    }
  };
  return <DivGlobalStyled theme={theme()}>
    <img src={icon} alt="icon"/>
    <DivStyled theme={theme()}>
      <p>
        {text}
      </p>
      <button>
        { buttonIcon !== null && buttonIcon !== undefined
          ? <img src={buttonIcon} alt="contact icon"/>
          : '' }
        {buttonText}
      </button>
    </DivStyled>
  </DivGlobalStyled>;
};
